const apps = {
  amSuite: '02A42623-0D2A-4948-917E-D767D8F706DC',
  employeeArchive: 'FC2185AE-F9AE-4969-8613-D104CDAA9D55',
  crm: '43F69893-CFAC-489E-8DB2-C15C822B3EB1',
  calendar: 'FDE75467-2B0E-4B90-BDD9-267E3CD6C84F',
  dialog: 'E0B363FE-0EBB-4740-88C1-C46001CCAB21',
  attendanceSheet: '3445BBF9-0CFE-4E7D-AE0E-09312F27E742',
  causalRequest: '3835D218-5E43-494E-8550-9E812A56C50E',
  clocking: '4F6DF298-3144-43C7-8395-BB8EE2D96F58',
  partySharedArchive: 'BFB3DE89-8054-480D-9819-F485E972A875',
  partyProfile: '6DE6F1B2-D309-47BF-B2E2-0E5699285FB4',
  refundedCosts: '66000A47-851F-4C33-AA24-61B279393F10',
  comunica: '4A5BD0CA-3AB2-4D68-9B1D-00B9B209187C',
}

const widgets = {
  partyClockings: 'A5E62C4E-6F19-463E-8F3C-EAEC65F7FD03',
  approveEntries: '59B8AB4A-C69C-454D-B597-3DFA00A38608',
  myRequests: '53B8D265-1188-4A5B-BE63-60A5B3F092B1',
  waitingRequests: 'FE7054AE-03F0-497D-B498-E26056F82EA8'
}

const guid = {
  empty: '00000000-0000-0000-0000-000000000000'
}

export { apps, widgets, guid };
